import { useSelector } from "react-redux";
import { CombinedShipmentBoard } from "../CombinedBoard/CombinedShipmentBoard";
import { MilestoneBoard } from "../MilestoneBoard/MilestoneBoard";
import { StatusBoardView } from "../Board/Board";
import { shouldHideEmptyLane } from "../../../../shipment/constants/shipmentCombinedBoard.js";
import { selectState } from "../../utils/tableDataElements";

/**
 * Renders the selected status or milestone board, including an empty milestone view.
 * @param {Object} props The selected view, page records, and interaction callbacks.
 * @return {React.ReactElement} The board columns.
 */
export function BoardView({
  selectedCurrentView,
  filteredOrderByStatus,
  statusCounts,
  filteredOrderByMilestone,
  orderType,
  shipmentOrders,
  getConsignmentByRule,
  handleSelectOrder,
  hideEmptyLanesMode = "none",
}) {
  const {
    status: { allViews: listOfStatusViews },
  } = useSelector(state => state[selectState[orderType]].allViews.boardView);

  if (selectedCurrentView.sub_type === "combined") {
    return (
      <CombinedShipmentBoard
        shipmentOrders={shipmentOrders}
        selectedCurrentView={selectedCurrentView}
        hideEmptyLanesMode={hideEmptyLanesMode}
        orderType={orderType}
        getConsignmentByRule={getConsignmentByRule}
        handleSelectOrder={handleSelectOrder}
      />
    );
  }

  const statusLaneList = listOfStatusViews[selectedCurrentView.value] || [];
  const statusPalette =
    orderType === "purchase" || orderType === "shipment" ? "journey" : undefined;

  return (
    <div className="boardView">
      {selectedCurrentView.sub_type === "milestone" ? (
        <MilestoneBoard
          shipmentOrders={shipmentOrders}
          selectedCurrentView={selectedCurrentView}
          filteredOrderByMilestone={filteredOrderByMilestone}
          orderType={orderType}
          statusPalette={statusPalette}
          hideEmptyLanesMode={hideEmptyLanesMode}
          handleSelectOrder={handleSelectOrder}
          getConsignmentByRule={getConsignmentByRule}
        />
      ) : (
        statusLaneList.length > 0 &&
        statusLaneList.map((status, ind) => {
          const laneOrders = filteredOrderByStatus ? filteredOrderByStatus[status] : [];
          if (
            (orderType === "shipment" || orderType === "purchase") &&
            shouldHideEmptyLane(hideEmptyLanesMode, "status", laneOrders?.length || 0)
          ) {
            return null;
          }
          return (
            <StatusBoardView
              key={status}
              filteredOrderByStatus={laneOrders}
              totalCount={orderType === "purchase" ? statusCounts?.[status] : undefined}
              status={status}
              ind={ind}
              orderType={orderType}
              statusPalette={statusPalette}
              getConsignmentByRule={getConsignmentByRule}
              selectedCurrentView={selectedCurrentView}
              handleSelectOrder={handleSelectOrder}
            />
          );
        })
      )}
    </div>
  );
}
